import { KYMW0900Model } from "../kymw0900.model";
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { GetWebLinkInfoRequestModel } from '../vo/kymw0900-get-web-link-info-request.model';

/**
 * Webリンク情報取得処理サービス
 *
 * @export GetWebLinkInfoService
 * @class GetWebLinkInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetWebLinkInfoService extends PlessJsonResponderSub<any> {

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetWebLinkInfoService
   */
  private successFunc: Function;

  model: KYMW0900Model;
  vo: GetWebLinkInfoRequestModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetWebLinkInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        PCodeCommon: {
          condition: {
            OrderCode: this.vo.orderCode,
            PCode: this.vo.pCode,
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetWebLinkInfoService
   */
  execute(model: any, vo: GetWebLinkInfoRequestModel, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getWebLinkInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetWebLinkInfoService
   */
  success(data: any): void {
    if (data !== null) {
      this.model.setWebLinkInfo(data);
      if (this.successFunc) {
        this.successFunc(data);
      }
    }
  }
}
